import * as Sentry from '@sentry/angular';
import { enableProdMode, ErrorHandler, LOCALE_ID, importProvidersFrom } from '@angular/core';
// LOCALE_ID is set to 'nl' below, but that only names the locale — DatePipe and DecimalPipe
// throw NG0701 unless its data is registered here as well, leaving every formatted cell blank.
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
registerLocaleData(localeNl);
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AdministrationInterceptor } from '@core/interceptors/administration.interceptor';
import { HttpErrorInterceptor } from '@core/interceptors/http-error.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from '@core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppComponent } from './app/app.component';

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};
const matComponents = [
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatListModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatSidenavModule,
  MatToolbarModule,
];



fetch('/assets/config.json')
  .then(res => res.json())
  .then(config => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).APP_CONFIG = config;

    Sentry.init({
      dsn: config.sentry.dsn,
      environment: config.sentry.environment,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1
    })

    if (config.production) {
      enableProdMode();
    }


    bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, ReactiveFormsModule, OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: ['http://localhost:4200', '/api', 'https://api.uft2.uwfactuur.eu', 'https://api.live.uwfactuur.eu'],
                sendAccessToken: true
            }
        }), AppRoutingModule, CoreModule, ToastrModule.forRoot({
            positionClass: 'toast-bottom-center'
        }), ...matComponents, NgxPermissionsModule.forRoot()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        { provide: HTTP_INTERCEPTORS, useClass: AdministrationInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearance },
        { provide: LOCALE_ID, useValue: 'nl' },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
      .catch(err => console.error(err));

  });


